import PriceFormatter from 'features/shared/components/formatters/PriceFormatter';
import { Currency } from 'features/shared/enums/currency';
import React from 'react';
import { useTranslation } from "react-i18next";
import { isInfoviceBeforeDueDate } from '../helpers/invoiceHelper';
interface Props {
  totalAmount: number;
  unpaidAmount: number;
  currency: Currency;
  dueDate: Date;
  showSubInfo?: boolean;
}

const InvoiceSimplifedPrices = ({ totalAmount, unpaidAmount, currency, dueDate, showSubInfo = true }: Props) => {
  // translations
  const tLabels = useTranslation("invoice\\invoice").t;

  // sub-renders
  const renderPrice = (amount: number, colorSuffix: "price" | "success" | "warning", amountCurrency: Currency = currency) => {
    return (
      <div className={`text-truncate text-${colorSuffix}`}>
        <PriceFormatter amount={amount} currency={amountCurrency} />
      </div>
    );
  }
  
  const renderOverpayment = (amount: number, amountCurrency: Currency = currency) => {
    return (
      <div className="text-truncate text-info">
        <PriceFormatter amount={amount} currency={amountCurrency} />
        {showSubInfo !== false &&
          <div className="small text-muted">{tLabels("invoiceSimplifiedPrices.overpayment")}</div>
        }
      </div>
    )
  }

  const renderPartiallyPaid = () => {
    // nadopaltek: amount > 0
    // přeplatek: amount < 0
    let title = totalAmount > 0 ? tLabels("invoiceSimplifiedPrices.pay") : tLabels("invoiceSimplifiedPrices.refund");
    let colorSuffix =  totalAmount > 0 ? "price" : "info";

    if (showSubInfo === false) {
      return (
        <div className={`text-truncate text-${colorSuffix}`}>
          <PriceFormatter amount={unpaidAmount} currency={currency} />
        </div>
      );
    } else {
      return (
        <div className="text-truncate">
          <PriceFormatter amount={totalAmount} currency={currency} />
          <div className={`text-${colorSuffix} small`}>
            <span>{title}: </span>
            <PriceFormatter amount={unpaidAmount} currency={currency} />
          </div>
        </div>
      );
    }
  }
  

  // render
  // vše zaplaceno
  if (unpaidAmount === 0) {
    // přeplatek
    if (totalAmount < 0) {
      return renderOverpayment(totalAmount); 
    } 
    // zaplacená částka
    else {
      return renderPrice(totalAmount, "success");
    }
  }
  // rovnost částek = zobrazí se pouze 1
  else if (totalAmount === unpaidAmount) {
    // neuhrazeno
    if (totalAmount > 0) {
      // doklad pred splatnosti
      if (isInfoviceBeforeDueDate(dueDate)) {
        return renderPrice(totalAmount, "warning");
      } else {
        return renderPrice(totalAmount, "price");
      }
    } 
    //  přeplatek
    else if (totalAmount < 0) {
      return renderOverpayment(totalAmount); 
    } 
  } 
  
  // částečně uhrazeno 
  else if (totalAmount !== unpaidAmount) {
    return renderPartiallyPaid();
  } 

  return <></>;
}

export default InvoiceSimplifedPrices;
